import { 
  BsHouseDoor, 
  BsSpeedometer2, 
  BsBullseye, 
  BsBuilding, 
  BsBarChart, 
  BsBook, 
  BsList, 
  BsDiagram3, 
  BsListTask,
  BsPieChart,
  BsPerson,
  BsGear
} from 'react-icons/bs';

export const menuItems = [
  {
    title: 'HEDEF İZLEME',
    items: [
      {
        title: 'Ana Sayfa',
        path: '/',
        icon: BsHouseDoor
      },
      {
        title: 'Genel Bakış',
        path: '/genel-bakis',
        icon: BsSpeedometer2
      }
    ]
  },
  {
    title: 'HEDEFLER',
    items: [
      {
        title: 'Hedefler',
        path: '/hedefler',
        icon: BsBullseye,
        isParent: true,
        subItems: [
          {
            title: 'Hedeflerim',
            path: '/hedefler/hedeflerim',
            icon: BsBullseye
          },
          {
            title: 'Üniversite Hedefleri',
            path: '/hedefler/universite',
            icon: BsBuilding
          },
          {
            title: 'Hedef Karşılaştır',
            path: '/hedefler/karsilastir',
            icon: BsBarChart
          }
        ]
      }
    ]
  },
  {
    title: 'YAYINLAR',
    items: [
      {
        title: 'Yayınlar',
        path: '/yayinlar',
        icon: BsBook,
        isParent: true,
        subItems: [
          {
            title: 'Yayınlar-Liste',
            path: '/yayinlar/liste',
            icon: BsList
          },
          {
            title: 'Yayınlar-Birimler',
            path: '/yayinlar/birimler',
            icon: BsBuilding
          }
        ]
      }
    ]
  },
  {
    title: 'PROJELER',
    items: [
      {
        title: 'Projeler',
        path: '/projeler',
        icon: BsDiagram3,
        isParent: true,
        subItems: [
          {
            title: 'Projeler-Liste',
            path: '/projeler/liste',
            icon: BsListTask
          }
        ]
      }
    ]
  },
  {
    title: 'AKADEMİSYENLER',
    items: [
      {
        title: 'Akademisyenler',
        path: '/akademisyenler',
        icon: BsPerson
      }
    ]
  },
  {
    title: 'BİRİMLER',
    items: [
      {
        title: 'Birimler',
        path: '/birimler',
        icon: BsBuilding
      }
    ]
  },
  {
    title: 'GRAFİKLER',
    items: [
      {
        title: 'Grafikler',
        path: '/grafikler',
        icon: BsPieChart
      }
    ]
  }
]; 